import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {LoginComponent} from './login.component';
import {ReactiveFormsModule} from "@angular/forms";
import {OfflineUploadComponent} from './components/offline-upload/offline-upload.component';
import { RouterModule } from "@angular/router";


@NgModule({
  declarations: [
    LoginComponent,
    OfflineUploadComponent
  ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule
    ]
})
export class LoginModule {
}
